import { Divider } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { defineAsyncComponent } from "vue";
import { setIsLoading as setIsLoadingApp } from "../../../../../app.logic";
import { callAddressType, createForm as createFormAddress } from "../../../../../components/address/address.logic";
import {
    createFieldCheckbox,
    createFieldDate,
    createFieldInput,
    createFieldInputNumber,
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTextArea
} from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { filter } from "../../../../../utils/search";
import { callGetHazLicenseReserveAndUse } from "../../../haz-mgt/buy/buy.section";
import { callCountry } from "../../../haz/request/haz-info/haz-info.section";
import { setIsSampling, setIsSequestrate, setSamplings, setSequestrates } from "../../../inspection/request/request.logic";
import { callQuantityUnit } from "./inform-product-qty.logic";

//const Address = defineAsyncComponent(() => import("../../../../../components/address/Address"));
const CardBorder = defineAsyncComponent(() => import("../../../../../components/card/CardBorder"));
const InformProductQtyList = defineAsyncComponent(() => import("./InformProductQtyList"));
const HazMainSubStanceList = defineAsyncComponent(() => import("./HazMainSubStanceList"));
const SequestrateInfoForm = defineAsyncComponent(() => import("../../../release/sequestrate/request/sequestrate-info/SequestrateInfoForm"));
const SamplingInfoForm = defineAsyncComponent(() => import("../../../release/sampling/request/sampling-info/SamplingInfoForm"));

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/informProduct";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const callHazSpecies = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_SPECIES", value: searchQuery })
        .then(items => items.filter(d => ["1", "2", "3"].includes(d.key)));
export const callHazObject = ({ searchQuery, notIn = [], species }) => {
    const where = [{ name: "isActive", type: "Boolean", operator: "=", value: true }];
    if (notIn?.length > 0) {
        where.push({ name: "id", type: "UUID", operator: "!in", value: notIn });
    }
    if (species?.length > 0) {
        where.push({ name: "refSpecies.key", type: "String", operator: "in", value: species });
    }
    if (searchQuery) {
        where.push({ name: "nameTh", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/master/hazObject/search", {
            criteria: {
                select: ["*", "refSpecies.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "nameTh", type: "ASC" }],
                children: [
                    {
                        name: "hazObjectCoordinates",
                        select: ["*", "refCoordinateCustoms.*", "refCoordinateCustoms.refUnit.*", "refCoordinateCustoms.refDetailSubStanceType.*"],
                        page: 0,
                        size: 1000000
                    }
                ]
            }
        })
        .then(page => page.data);
};
export const callHaz = ({ searchQuery, refUserCompanyId, refHazSpeciesKey, refOperationKey, notIn = [] }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },
        { name: "hazLicenseDetails.refHazLicense.isActive", type: "Boolean", operator: "=", value: true },
        { name: "hazLicenseDetails.refHazLicense.isTemp", type: "Boolean", operator: "=", value: false },
        { name: "hazLicenseDetails.refHazLicense.refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "hazLicenseDetails.refHazLicense.effectiveDate", type: "Date", operator: "<=", value: moment().format("YYYY-MM-DD") },
        { name: "hazLicenseDetails.refHazLicense.expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") }
    ];
    if (refOperationKey) {
        where.push({ name: "hazLicenseDetails.refHazLicense.refOperation.key", type: "String", operator: "=", value: refOperationKey });
    }
    if (refHazSpeciesKey) {
        where.push({ name: "refHazObject.refSpecies.key", type: "String", operator: "=", value: refHazSpeciesKey });
    }
    if (refUserCompanyId) {
        where.push({ name: "hazLicenseDetails.refHazLicense.refUserCompany.id", type: "UUID", operator: "=", value: refUserCompanyId });
    }
    if (notIn?.length > 0) {
        where.push({ name: "id", type: "UUID", operator: "!in", value: notIn });
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/haz/search", {
            criteria: {
                isDistinct: true,
                select: ["*"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};
export const callHazFull = ({ id, refOperationKey, refUserCompanyId }) => {
    return store
        .dispatch("resource/v1/transaction/haz/search", {
            criteria: {
                isDistinct: true,
                select: ["*", "refHazObject.*", "refHazObject.refSpecies.*", "refManufactureCountry.*"],
                page: 0,
                size: 1000000,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                children: [
                    {
                        name: "refHazObject.hazObjectCoordinates",
                        select: ["*", "refCoordinateCustoms.*", "refCoordinateCustoms.refUnit.*", "refCoordinateCustoms.refDetailSubStanceType.*"],
                        page: 0,
                        size: 1000000
                    },
                    {
                        name: "hazLicenseDetails",
                        select: ["*", "refHazLicense.*", "refHazLicense.refQuantityUnit.*"],
                        page: 0,
                        size: 1,
                        where: [
                            { name: "refHazLicense.isActive", type: "Boolean", operator: "=", value: true },
                            { name: "refHazLicense.isTemp", type: "Boolean", operator: "=", value: false },
                            { name: "refHazLicense.refStatus.key", type: "String", operator: "=", value: "complete" },
                            { name: "refHazLicense.effectiveDate", type: "Date", operator: "<=", value: moment().format("YYYY-MM-DD") },
                            { name: "refHazLicense.expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },
                            { name: "refHazLicense.refOperation.key", type: "String", operator: "=", value: refOperationKey },
                            { name: "refHazLicense.refUserCompany.id", type: "UUID", operator: "=", value: refUserCompanyId },
                        ],
                        children: [
                            {
                                name: "refHazLicense.hazLicenseStorageLocations",
                                select: ["*", "refStorageLocation.*"],
                                page: 0,
                                size: 1000000,
                                where: [
                                    { name: "refStorageLocation.isActive", type: "Boolean", operator: "=", value: true },
                                    { name: "refStorageLocation.isTemp", type: "Boolean", operator: "=", value: false },
                                    { name: "refStorageLocation.refStatus.key", type: "String", operator: "=", value: "complete" },
                                    { name: "refStorageLocation.effectiveDate", type: "Date", operator: "<=", value: moment().format("YYYY-MM-DD") },
                                    { name: "refStorageLocation.expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },
                                    { name: "refStorageLocation.isLocation", type: "Boolean", operator: "=", value: true }
                                ],
                                sort: [{ name: "createDate", type: "ASC" }],
                                children: [
                                    {
                                        name: "refStorageLocation.subs",
                                        select: ["*"],
                                        page: 0,
                                        size: 1000000,
                                        sort: [{ name: "createDate", type: "ASC" }],
                                        children: [
                                            {
                                                name: "items",
                                                select: ["*"],
                                                page: 0,
                                                size: 1000000,
                                                where: [
                                                    { name: "refHaz.id", type: "ScriptJs", operator: "=", value: "dataRoot.id" },
                                                    {
                                                        name: "refHazLicense.refOperation.key",
                                                        type: "String",
                                                        operator: "=",
                                                        value: "2"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        name: "mainSubStances",
                        select: ["*", "refSubStance.*", "refUnit.*"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    }
                ]
            }
        })
        .then(page => page.data[0]);
};
export const callStorageLocation = ({ searchQuery, refUserCompanyId }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "effectiveDate", type: "Date", operator: "<=", value: moment().format("YYYY-MM-DD") },
        { name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },
        { name: "isLocation", type: "Boolean", operator: "=", value: true }
    ];
    if (refUserCompanyId) {
        where.push({ name: "refUserCompany.id", type: "UUID", operator: "=", value: refUserCompanyId });
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/storageLocation/search", {
            criteria: {
                select: ["id", "version", "approveCode", "name"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const createField = ({ props, data, key, items, initItems, isLoading }) => {
    return putField({
        data,
        fields: [
            ...createField1({ props, data, key, items, initItems, isLoading }),
            ...createField2({ props, data, key, items, initItems, isLoading })
        ]
    });
};

const yesNo = [
    { id: "1", value: true, name: i18n.global.t("model.inspection.labels.isCheck") },
    { id: "2", value: false, name: i18n.global.t("model.inspection.labels.isNotCheck") }
];

export const createField1 = ({ props, data, key, /* items , initItems , isLoading */ }) => {
    const { viewOnly, informKey } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const initModel = key ? lodash.get(initialModel, key) : initialModel;
    const prefix = key ? `${key}.` : "";
    const modelInform = lodash.get(modelRef, informKey);
    return putField({
        data,
        fields: [
            // createFieldCheckbox({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
            //     key: `${prefix}isCheck`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => i18n.global.t("model.inspectionProduct.isCheck"),
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             {
            //                 checked: model.isCheck,
            //                 "onUpdate:checked": checked => {
            //                     model.isCheck = checked;
            //                     model.setIsCheck?.({ modelRef, id: model?.id, checked });
            //                 },
            //                 disabled: viewOnly,
            //                 text: () => i18n.global.t("button.yes")
            //             },
            //             conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field, model } })
            //         )
            // }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}isCheck`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inspectionProduct.isCheck"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value:
                                model.isCheck === true
                                    ? yesNo.find(d => d.id === "1")
                                    : model.isCheck === false
                                    ? yesNo.find(d => d.id === "2")
                                    : undefined,
                            "onUpdate:value": value => {
                                const checked = value?.value;
                                model.isCheck = checked;
                                model.setIsCheck?.({ modelRef, id: model?.id, checked });
                            },
                            disabled: viewOnly,
                            list: () => yesNo,
                            optLabel: "name"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) }
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}isSequestrate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.releaseProduct.isSequestrate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isSequestrate,
                            "onUpdate:checked": checked => {
                                model.isSequestrate = checked;
                                model.setIsSequestrate?.({ modelRef, id: model?.id, checked });
                            },
                            disabled: viewOnly,
                            text: () => i18n.global.t("button.yes")
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field, model } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}isSampling`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.releaseProduct.isSampling"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isSampling,
                            "onUpdate:checked": checked => {
                                model.isSampling = checked;
                                model.setIsSampling?.({ modelRef, id: model?.id, checked });
                            },
                            disabled: viewOnly,
                            text: () => i18n.global.t("button.yes")
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field, model } })
                    )
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refHazSpecies`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.refHazSpecies"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazSpecies,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.refHazSpecies = value;
                                model.refHaz = null;
                                model.refHazLicense = null;
                                model.refHazObject = null;
                                model.refCoordinateCustoms = null;
                                model.refOriginDestinationCountry = null;
                                model.manufacturer = null;
                                model.refStorageLocation = null;
                                model.tradeName = null;

                                if (["16", "17"].includes(modelRef.refRequestDoc?.key)) {
                                    lodash.remove(model.productQties, d => !d.id);
                                    model.productQties.forEach(d => (d.isDelete = true));
                                    if (value?.key === "1") {
                                        callAddressType({}).then(addressTypes => {
                                            model.addresses.unshift({
                                                ...createFormAddress(),
                                                refAddressType: addressTypes.find(d => d.key === "1")
                                            });
                                        });
                                        callQuantityUnit({}).then(quantityUnits => {
                                            model.productQties.unshift({
                                                refQtyUnit: quantityUnits.find(d => d.key === "KGM"),
                                                refNetWeightUnit: quantityUnits.find(d => d.key === "KGM"),
                                                refPackageUnit: quantityUnits.find(d => d.key === "KGM")
                                            });
                                        });
                                    } else {
                                        lodash.remove(model.addresses, d => !d.id);
                                        model.addresses.forEach(d => (d.isDelete = true));
                                    }
                                }
                            },
                            disabled: viewOnly,
                            list: callHazSpecies,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refHaz`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.refHaz"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHaz,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.refHaz = null;
                                model.refHazLicense = null;
                                model.refHazObject = null;
                                model.refCoordinateCustoms = null;
                                model.refOriginDestinationCountry = null;
                                model.manufacturer = null;
                                model.refStorageLocation = null;
                                model.tradeName = null;
                                lodash.remove(model.productQties, d => !d.id);
                                model.productQties.forEach(d => (d.isDelete = true));

                                if (value) {
                                    callHazFull({
                                        id: value.id,
                                        refOperationKey: modelInform.refOperation?.key,
                                        refUserCompanyId: modelInform.refUserCompany?.id,
                                    }).then(haz => {
                                        model.refHaz = haz;
                                        model.refHazLicense = haz.hazLicenseDetails?.[0]?.refHazLicense;
                                        model.refCoordinateCustoms = null;
                                        model.refHazObject = haz.refHazObject;
                                        model.refOriginDestinationCountry = haz.refManufactureCountry;
                                        model.manufacturer = haz.manufacturer;
                                        model.tradeName = haz.tradeNameTh;
                                        if (value) {
                                            setIsLoadingApp(true);
                                            callGetHazLicenseReserveAndUse({ hazLicenseId: model.refHazLicense.id })
                                                .then(d => {
                                                    model.refHazLicense.quantityReserve = d.reserve;
                                                    model.refHazLicense.quantityUse = d.use;
                                                })
                                                .finally(() => setIsLoadingApp(false));
                                        }
                                    });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callHaz({
                                    searchQuery,
                                    refUserCompanyId: modelInform.refUserCompany?.id,
                                    refHazSpeciesKey: model.refHazSpecies?.key,
                                    refOperationKey: modelInform.refOperation?.key,
                                    notIn: []
                                    // notIn: items
                                    //     .filter(d => d.isDelete !== true)
                                    //     .map(d => d.refHaz?.id)
                                    //     .filter(d => d)
                                }),
                            optLabel: "approveCode"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.approveCode`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refHazLicense.approveCode`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () =>
                    model.refHazSpecies?.key === "2"
                        ? i18n.global.t("views.request.informProduct.licenseNotic")
                        : i18n.global.t("views.request.informProduct.license"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazLicense?.approveCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <div></div>
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}invoiceCode`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.invoiceCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.invoiceCode,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.invoiceCode = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}invoiceDate`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.invoiceDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.invoiceDate,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.invoiceDate = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}invoiceSeq`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.invoiceSeq"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.invoiceSeq,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.invoiceSeq = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refHazObject`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.refHazObject"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazObject,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.refHazObject = value;
                                model.refCoordinateCustoms = null;
                                if (modelRef.refRequestDoc?.key === "02") {
                                    model.refHazSpecies = value?.refSpecies;
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callHazObject({
                                    searchQuery,
                                    // notIn: ["1"].includes(model.refHazSpecies?.key) ? [] : items.filter(d => d.isDelete !== true).map(d => d.refHazObject?.id).filter(d => d),
                                    notIn: [],
                                    species: ["02"].includes(data.useForm.modelRef.refRequestDoc?.key) ? ["2", "3"] : [model.refHazSpecies?.key]
                                }),
                            optLabel: "nameTh"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refHazObject.refSpecies.value`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazObject.refSpecies"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazObject?.refSpecies?.value,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refOriginDestinationCountry`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.refOriginDestinationCountry"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginDestinationCountry,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.refOriginDestinationCountry = value;
                            },
                            disabled: viewOnly,
                            list: callCountry,
                            renderLabel: ({ item }) => (
                                <span>
                                    {item.nameEnS} : {item.nameTh}
                                </span>
                            )
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}nature`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.nature"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.nature,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.nature = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}formula`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.formula"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.formula,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.formula = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refCoordinateCustoms`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.refCoordinateCustoms"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refCoordinateCustoms,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.refCoordinateCustoms = value;
                            },
                            disabled: viewOnly || !model.refHazObject,
                            list: ({ searchQuery }) =>
                                filter({
                                    list: model.refHazObject?.hazObjectCoordinates.map(d => d.refCoordinateCustoms),
                                    where: [{ name: "name", type: "String", operator: "like", value: searchQuery }],
                                    sort: [{ name: "name", type: "ASC" }]
                                }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.name} {item.code}/{item.refUnit?.value}={model.refHazObject?.nameTh}
                                    {item.refDetailSubStanceType?.value}
                                </div>
                            )
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.name`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}manufacturer`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.manufacturer"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.manufacturer,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.manufacturer = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refStorageLocation`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.refStorageLocation"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refStorageLocation,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.refStorageLocation = value;
                                if (["02"].includes(modelRef.refRequestDoc?.key) && value?.name) {
                                    model.storageName = value.name
                                } else {
                                    model.storageName = null;
                                }
                            },
                            disabled: viewOnly || !modelInform.refUserCompany,
                            list: ({ searchQuery }) => callStorageLocation({ searchQuery, refUserCompanyId: modelInform.refUserCompany?.id }),
                            optLabel: "name"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.name`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}storageName`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.storageName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.storageName,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.storageName = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            /*
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refHaz.tradeNameTh`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.tradeNameTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHaz?.tradeNameTh,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            */
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}tradeName`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.tradeName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.tradeName,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.tradeName = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}quantityRemaining`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazLicense.quantityRemaining"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: calQuantityRemaining({
                                hazLicense: model.refHazLicense,
                                initInformProductQties: initModel?.productQties,
                                informProductQties: model.productQties
                            }),
                            disabled: true,
                            allowPrecision: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            })
        ]
    });
};

export const createField2 = ({ props, data, key, items, initItems /* , isLoading */ }) => {
    const { viewOnly, menuContext, informKey, request, viewOnlyInspection, isCombineQty } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const initModel = key ? lodash.get(initialModel, key) : initialModel;
    const prefix = key ? `${key}.` : "";
    const modelInform = lodash.get(modelRef, informKey);
    const initModelInform = lodash.get(initialModel, informKey);
    return putField({
        data,
        fields: [
            /*
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}addresses.0`,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    if (!model.addresses?.some(d => d.isDelete !== true)) {
                        return null;
                    }
                    return (
                        <>
                            <Divider class="text-bold text-16" orientation="left">
                                {model.addresses?.[0]?.refAddressType?.value}
                            </Divider>
                            <Address
                                menuContext={menuContext}
                                viewOnly={viewOnly}
                                dataProp={data}
                                dataKey={`${prefix}addresses.0`}
                                isLoading={isLoading.value}
                                locale={[{ name: "Th", suffix: false }]}
                                onUpdateSome={() => (model.isSave = true)}
                            ></Address>
                        </>
                    );
                }
            },
            */
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refHaz.mainSubStances`,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    if (!model.refHaz) {
                        return null;
                    }
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}refHaz.mainSubStances`,
                            canCreate: false,
                            canDelete: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "HazMainSubStanceList" } })
                    );
                    return (
                        <>
                            <Divider class="text-bold text-16" orientation="left">
                                {i18n.global.t("views.request.hazMainSubStance.title")}
                            </Divider>
                            <HazMainSubStanceList {...componentProp}></HazMainSubStanceList>
                        </>
                    );
                }
            },
            {
                visible: () =>
                    conditionFormChecker({ props, data, executeKey: "visibleField", params: { componentKey: "InformProductQtyList", model } }),
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            viewOnlyInspection: viewOnlyInspection,
                            isCombineQty: isCombineQty,
                            dataProp: data,
                            itemsKey: `${prefix}productQties`,
                            fetchCriteria: data.productQty?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly,
                            visiblePagination: true,
                            request,
                            inform: modelInform,
                            initInform: initModelInform,
                            informProduct: model,
                            initInformProduct: initModel,
                            informProducts: items,
                            initInformProducts: initItems,
                            hazLicense: model.refHazLicense,
                            storageLocations: model.refHazLicense?.hazLicenseStorageLocations?.map(d => d.refStorageLocation) || [],
                            showStorageLocation: false,
                            showLot: false,
                            balanceOnly: props?.balanceOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "InformProductQtyList", model } })
                    );
                    let remark = undefined;
                    if (["2", "3"].includes(model.refHazSpecies?.key) && modelInform.refOperation?.key === "2") {
                        remark = <div class="text-danger">{i18n.global.t("views.request.informProductQty.remark")}</div>;
                    }
                    return (
                        <>
                            <Divider class="text-bold text-16" orientation="left">
                                {i18n.global.t("views.request.informProductQty.title")}
                            </Divider>
                            <InformProductQtyList {...componentProp}></InformProductQtyList>
                            {remark}
                        </>
                    );
                }
            },
            {
                visible: () =>
                    conditionFormChecker({ props, data, executeKey: "visibleField", params: { componentKey: "SequestrateInfoForm", model } }),
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    let dataKey = `${prefix}sequestrates.0`;
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnlyInspection,
                            dataProp: data,
                            dataKey,
                            request,
                            inform: modelInform,
                            initInform: initModelInform,
                            informProduct: model,
                            initInformProduct: initModel,
                            informProducts: items,
                            initInformProducts: initItems
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "SequestrateInfoForm", model } })
                    );
                    return (
                        <CardBorder title={i18n.global.t("model.sequestrate.modelName")} class="mt-3">
                            <SequestrateInfoForm {...componentProp}></SequestrateInfoForm>
                        </CardBorder>
                    );
                }
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: "visibleField", params: { componentKey: "SamplingInfoForm", model } }),
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    let dataKey = `${prefix}samplings.0`;
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnlyInspection,
                            dataProp: data,
                            dataKey,
                            request,
                            inform: modelInform,
                            initInform: initModelInform,
                            informProduct: model,
                            initInformProduct: initModel,
                            informProducts: items,
                            initInformProducts: initItems
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "SamplingInfoForm", model } })
                    );
                    return (
                        <CardBorder title={i18n.global.t("model.sampling.modelName")} class="mt-3">
                            <SamplingInfoForm {...componentProp}></SamplingInfoForm>
                        </CardBorder>
                    );
                }
            }
        ]
    });
};

export const initData = ({ props, data }) => {
    const { itemsKey, isCombineQty } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    let items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    let initItems = itemsKey ? lodash.get(initialModel, itemsKey) : initialModel;
    if (itemsKey) {
        if (!items) {
            lodash.set(modelRef, itemsKey, []);
            items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
        }
        if (!initItems) {
            lodash.set(initialModel, itemsKey, []);
            initItems = itemsKey ? lodash.get(initialModel, itemsKey) : initialModel;
        }
    }
    fetchData({ props, data }).then(page => {
        const fetchItems = page.data.map(d => ({ ...d, productQties: [] }));
        items?.push(...lodash.cloneDeep(fetchItems));
        initItems?.push(...lodash.cloneDeep(fetchItems));
        fetchItems.forEach(item => {
            lodash.set(data, `productQty.${item.id}.fetchCriteria`, {
                select: ["**", "refInformProduct.refTransferDeclarationProduct.*"],
                page: 0,
                size: 1000000,
                where: [{ name: "refInformProduct.id", type: "UUID", operator: "=", value: item.id }],
                sort: [{ name: "createDate", type: "ASC" }],
                children: [
                    {
                        name: "refStorageLocation.subs",
                        select: ["*"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [
                            {
                                name: "items",
                                select: ["*"],
                                page: 0,
                                size: 1000000,
                                where: [
                                    { name: "refHaz.id", type: "UUID", operator: "=", value: item.refHaz?.id },
                                    {
                                        name: "refHazLicense.refOperation.key",
                                        type: "String",
                                        operator: "=",
                                        value: "2"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        name: "refStorageLocationSub.items",
                        select: ["*"],
                        page: 0,
                        size: 1000000,
                        where: [{ name: "refHaz.id", type: "UUID", operator: "=", value: item.refHaz?.id }]
                    },
                    {
                        name: "inspectionProductQties",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        where: [
                            {
                                name: "refInspectionProduct.refInspection.id",
                                type: "UUID",
                                operator: "=",
                                value: modelRef.refReleaseTemp?.refInspection?.id
                            },
                            { name: "isActive", type: "Boolean", operator: "=", value: true }
                        ],
                        children: [
                            {
                                name: "releaseProductQties",
                                select: ["**"],
                                page: 0,
                                size: 1000000,
                                sort: [{ name: "createDate", type: "ASC" }],
                                where: [
                                    { name: "refReleaseProduct.refRelease.id", type: "UUID", operator: "=", value: modelRef.refReleaseTemp?.id },
                                    { name: "isActive", type: "Boolean", operator: "=", value: true }
                                ]
                            }
                        ]
                    },
                    {
                        name: "refInformProduct.refTransferDeclarationProduct.productQties",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    }
                ]
            });
        });
        if (isCombineQty) {
            combineProduct({ props, data, page });
        }
    });
};

export const fetchData = ({ props, data }) => {
    const { fetchCriteria } = props;
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    if (!fetchCriteria || fetchCriteria.fetched || items?.length) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria })
        .then(page => {
            return callGetHazLicenseReserveAndUse({
                hazLicenseId: lodash.uniq(page.data.map(informProduct => informProduct.refHazLicense?.id).filter(d => d))
            })
                .then(reserveUses => {
                    page.data.forEach(informProduct => {
                        if (informProduct.refHazLicense) {
                            const reserveUse = reserveUses.find(reserveUse => reserveUse.refHazLicenseId === informProduct.refHazLicense.id);
                            informProduct.refHazLicense.quantityReserve = reserveUse.reserve;
                            informProduct.refHazLicense.quantityUse = reserveUse.use;
                        }
                    });
                })
                .then(() => page);
        })
        .finally(() => setIsLoading(false));
};

export const calQuantityRemaining = ({ hazLicense, initInformProductQties, informProductQties }) => {
    if (!hazLicense) {
        return 0;
    }
    let quantityRemaining =
        parseFloat(hazLicense.quantity || 0) - parseFloat(hazLicense.quantityReserve || 0) - parseFloat(hazLicense.quantityUse || 0);
    initInformProductQties
        ?.filter(d => d.netWeight?.toString())
        ?.forEach(d => (quantityRemaining = parseFloat(quantityRemaining) + parseFloat(d.netWeight)));
    informProductQties
        ?.filter(d => d.netWeight?.toString())
        ?.filter(d => d.isDelete !== true)
        ?.forEach(d => (quantityRemaining = parseFloat(quantityRemaining) - parseFloat(d.netWeight)));
    return quantityRemaining;
};

const combineProduct = ({ props, data }) => {
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.isCombinedQty = false;
    if (modelRef.refReleaseTemp?.refInspection) {
        const releaseProducts = modelRef.refReleaseTemp?.products;
        const inspectionProducts = modelRef.refReleaseTemp?.refInspection?.products;
        items.forEach(product => {
            const inspectionProduct = inspectionProducts.find(d => d.refInformProduct.id === product.id || d.refInformProduct.id === product._id);
            const releaseProduct = releaseProducts.find(
                d => d.refInspectionProduct.refInformProduct.id === product.id || d.refInspectionProduct.refInformProduct.id === product._id
            );
            product.samplings = [...(releaseProduct?.samplings || [])];
            product.sequestrates = [...(releaseProduct?.sequestrates || [])];
            product.setIsSequestrate = setIsSequestrate;
            product.setIsSampling = setIsSampling;
            product.setSamplings = setSamplings;
            product.setSequestrates = setSequestrates;
            product.isCheck = inspectionProduct?.isCheck;
            product.isSequestrate = releaseProduct?.isSequestrate;
            product.isSampling = releaseProduct?.isSampling;
        });
    }
    data.isCombinedQty = true;
};
